import axios from 'axios';

import {loadScript} from '../utils';

import './responsive.css';
import './theme.css';

export const GDPR_SCRIPT = 'https://cmp.dmgmediaprivacy.co.uk/2.8.2-newssearch.3/iife/mol-ads-cmp.min.js';
export const LOCATION_FILE = '/locationjson.html';

interface LocationResponse {
  Country: string;
  CITY: string;
  INEU: boolean;
}

export const loadIfNeeded = async ({render = true} = {}) => {
  try {
    const {data} = await axios.get<LocationResponse>(LOCATION_FILE, {responseType: 'json'});

    if (!data.INEU) {
      return false;
    }

    const params: {[key: string]: string} = {
      id: 'mol-ads-cmp'
    };

    if (render) {
      params['data-render'] = 'true';
    }

    await loadScript(GDPR_SCRIPT, params);

    return true;
  } catch (error) {
    // Do not load
    return false;
  }
};
